import { render, staticRenderFns } from "./CreateConfigureShiftEmployee.vue?vue&type=template&id=05a3433b&scoped=true"
import script from "./CreateConfigureShiftEmployee.vue?vue&type=script&lang=js"
export * from "./CreateConfigureShiftEmployee.vue?vue&type=script&lang=js"
import style0 from "./CreateConfigureShiftEmployee.vue?vue&type=style&index=0&id=05a3433b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3433b",
  null
  
)

export default component.exports